import React from 'react';
const points = [{
  num: '01',
  title: 'Domenica sera = stress totale.',
  desc: 'Passi ore a cercare workout e circuiti per il lunedì.'
}, {
  num: '02',
  title: 'Programmazione casuale.',
  desc: 'Senti che le tue classi non seguono una vera struttura professionale.'
}, {
  num: '03',
  title: 'Sempre gli stessi esercizi.',
  desc: 'Hai paura di annoiare clienti e gruppi.'
}, {
  num: '04',
  title: 'Troppe cose da gestire.',
  desc: 'Clienti, messaggi, programmazioni, social, mobility, women training… e la testa esplode.'
}, {
  num: '05',
  title: 'Vuoi sembrare più professionale.',
  desc: 'Vuoi che i clienti percepiscano il tuo coaching come premium.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden border-y border-border-light" data-id="element-158">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-159"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-primary/8 rounded-full blur-[100px] pointer-events-none" data-id="element-160"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-161">
        <div className="text-center mb-12" data-id="element-162">
          <h2 className="font-display text-3xl sm:text-5xl font-bold text-white mb-4 tracking-tight uppercase" data-id="element-163">
            👀 Ti suona familiare?
          </h2>
          <p className="text-text-sec text-base sm:text-lg" data-id="element-164">
            Functional Pronto è per te se vivi questo:
          </p>
        </div>

        <div className="space-y-4" data-id="element-165">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt rounded-sm p-6 border border-border-light hover:border-primary/50 transition-colors group relative overflow-hidden" data-id="element-166">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary/0 group-hover:bg-primary transition-colors" data-id="element-167"></div>
              <span className="font-display text-primary font-bold text-3xl sm:text-4xl flex-shrink-0 leading-none mt-0.5 tracking-tight" data-id="element-168">
                {point.num}
              </span>
              <div data-id="element-169">
                <h3 className="text-white text-lg sm:text-xl font-bold mb-1.5 font-display uppercase tracking-wide" data-id="element-170">
                  {point.title}
                </h3>
                <p className="text-text-sec text-base font-medium leading-relaxed" data-id="element-171">
                  {point.desc}
                </p>
              </div>
            </div>)}
        </div>

        <p className="text-center text-white font-bold text-lg sm:text-xl mt-10" data-id="element-172">
          ✋ Ti sei riconosciuto?{' '}
          <span className="text-primary block sm:inline mt-1 sm:mt-0" data-id="element-173">
            Allora questo sistema è stato creato per te.
          </span>
        </p>
      </div>
    </section>;
}